// import axios from "axios";

import apiInstance from '../services';
import ApiConstants from '../services/apiConstants';

export const userRegister = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstance.post(ApiConstants.USER_REGISTER, data)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const userLogin = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstance.post(ApiConstants.USER_REGISTER, data)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const generateLink = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstance.post(ApiConstants.GENERATE_URL, data)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCustomerFormData = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstance.get(`${ApiConstants.GET_FORM_DATA}${data}`)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getValidRegistrationNumber = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstance.get(
        `${ApiConstants.GET_VALID_REGISTRATION_NUMBER}${data}`
      )
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getPreferedPartnerDataService = async (data: any) => {
  //   const dataSaurce = [
  //     {
  //         "id": 4,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 5,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 6,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 7,
  //         "label": "Example Partner Co.",
  //         "value": "active"
  //     },
  //     {
  //         "id": 8,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 9,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 10,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     }
  // ]
  try {
    return Promise.resolve(await apiInstance.get(`/partnerIDs`));
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getValidApplicantEmail = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstance.get(`${ApiConstants.GET_VALID_APPLICANT_EMAIL}${data}`)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};
